export function isQrInbox(inbox) {
  if (inbox?.channel_type !== 'Channel::Api') return false;
  try {
    const url = new URL(inbox.webhook_url);
    return url.protocol === 'https:' && url.hostname === 'evolution.devlive.tech' &&
      /^\/chatwoot\/webhook(?:\/|$)/.test(url.pathname);
  } catch { return false; }
}
